// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#password-form[data-v-822476f2]{margin-top:2em}.el-card[data-v-822476f2]{padding:15px}", ""]);
// Exports
module.exports = exports;
